module.exports = __webpack_public_path__ + "static/media/header-notification.83fef811.svg";